import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const AbvPriceActionPctList = ({ priceActionPctGrpId }) => {
  const augRowsReq = useCallback(
    (rowsReq) => {
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('priceActionPctGrpId', priceActionPctGrpId));
    },
    [priceActionPctGrpId],
  );

  return <EntityList entity="PRICE_ACTION_PCT" augRowsReq={augRowsReq} />;
};
